/**
 * ⚽ Market Switcher — Atlético Nacional
 *
 * Selector de tienda (Colombia ⇄ Internacional) en el header y en el menú móvil.
 * Solo abre y cierra el panel: el destino y sus parámetros ya vienen resueltos
 * en el href desde Liquid, así que el enlace navega de forma nativa aunque el
 * JS falle o llegue tarde.
 *
 * Todo funciona por delegación en `document`, de modo que el menú lateral —que
 * el theme inyecta por AJAX después de cargar la página— no necesita re-init.
 *
 * No toca ningún estado, clase ni evento de otros componentes del theme.
 */
(function () {
  "use strict";

  var ROOT = "[data-market-switcher]";
  var CLOSE_MS = 220;

  function each(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }

  function openPanels() {
    return document.querySelectorAll(ROOT + ".is-open");
  }

  /* ---------------------------------------------------------- analítica */

  /**
   * Mismo criterio que la modal: con "auto" prefiere gtag y cae a dataLayer,
   * para no duplicar la medición si conviven gtag.js y GTM.
   */
  function sendEvent(root, name, extra) {
    if (root.getAttribute("data-events-enable") !== "true") return;

    var params = {
      store_role: root.getAttribute("data-role") || "",
      current_store: root.getAttribute("data-current-label") || "",
      target_store: root.getAttribute("data-target-host") || "",
      placement: root.getAttribute("data-variant") || ""
    };
    for (var key in extra) {
      if (Object.prototype.hasOwnProperty.call(extra, key)) params[key] = extra[key];
    }

    var channel = root.getAttribute("data-events-channel") || "auto";
    var hasGtag = typeof window.gtag === "function";
    var hasLayer = !!(window.dataLayer && typeof window.dataLayer.push === "function");

    if (channel !== "datalayer" && hasGtag) {
      window.gtag("event", name, params);
      return;
    }
    if (channel !== "gtag" && hasLayer) {
      params.event = name;
      window.dataLayer.push(params);
    }
  }

  /* -------------------------------------------------------------- panel */

  function panelOf(root) {
    return root.querySelector("[data-am-ms-panel]");
  }

  function toggleOf(root) {
    return root.querySelector("[data-am-ms-toggle]");
  }

  function open(root) {
    var panel = panelOf(root);
    var toggle = toggleOf(root);
    if (!panel || root.classList.contains("is-open")) return;

    closeAll(root);
    if (root.closeTimer) {
      clearTimeout(root.closeTimer);
      root.closeTimer = null;
    }

    panel.removeAttribute("hidden");
    requestAnimationFrame(function () {
      root.classList.add("is-open");
    });
    if (toggle) toggle.setAttribute("aria-expanded", "true");

    sendEvent(root, "market_switcher_open");
  }

  function close(root, refocus) {
    var panel = panelOf(root);
    var toggle = toggleOf(root);
    if (!panel || !root.classList.contains("is-open")) return;

    root.classList.remove("is-open");
    if (toggle) toggle.setAttribute("aria-expanded", "false");

    root.closeTimer = setTimeout(function () {
      if (!root.classList.contains("is-open")) panel.setAttribute("hidden", "");
    }, CLOSE_MS);

    if (refocus && toggle && typeof toggle.focus === "function") toggle.focus();
  }

  function closeAll(except) {
    each(openPanels(), function (root) {
      if (root !== except) close(root);
    });
  }

  /* ----------------------------------------------------------- eventos */

  document.addEventListener("click", function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== "function") return;

    var toggle = target.closest("[data-am-ms-toggle]");
    if (toggle) {
      var root = toggle.closest(ROOT);
      if (!root) return;
      // El disparador es un <button type="button">: no navega ni envía nada.
      // Cortamos la propagación para que los manejadores delegados del theme
      // (menú móvil, drawers) no interpreten el clic como suyo.
      event.preventDefault();
      event.stopPropagation();
      if (root.classList.contains("is-open")) close(root);
      else open(root);
      return;
    }

    var go = target.closest("[data-am-ms-go]");
    if (go) {
      var goRoot = go.closest(ROOT);
      // Sin preventDefault: el <a> navega de forma nativa, así siguen
      // funcionando cmd+clic y el decorado de enlaces de GA4/GTM.
      if (goRoot) sendEvent(goRoot, "market_switcher_switch");
      return;
    }

    if (!target.closest(ROOT)) closeAll();
  });

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape" && event.keyCode !== 27) return;
    each(openPanels(), function (root) {
      close(root, true);
    });
  });

  // Al salir con Tab del componente se cierra, como cualquier menú desplegable.
  document.addEventListener("focusin", function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== "function") return;
    var inside = target.closest(ROOT);
    each(openPanels(), function (root) {
      if (root !== inside) close(root);
    });
  });

  // El editor de temas re-renderiza secciones: si el panel quedó abierto en un
  // nodo que ya no existe, no hay nada que limpiar (los listeners son globales).
})();
